<mat-card class="campaign-card mat-elevation-z4">
  <mat-card-title class="card-title">
    <img class="card-img" mat-card-image [src]="campaign.imagemWeb" />
  </mat-card-title>
  <mat-card-content>
    <h6>{{ campaign.titulo }}</h6>
    @if (showDescription) {
      <p>{{ campaign.descricao }}</p>
    }
  </mat-card-content>
  <mat-card-actions>
    <div class="d-flex align-items-center justify-content-between">
      @if (campaign.link) {
        <a class="detail-btn" mat-mini-fab [href]="campaign.link" target="_blank">
          <mat-icon fontSet="material-icons">add</mat-icon>
        </a>
      }

      @if (showAction) {
        <div class="d-flex align-items-center">
          <span class="slider-text">Marcar como Lido</span>
          <mat-slide-toggle class="slider" color="accent" [checked]="checked" (change)="toggledCheck.emit()">
          </mat-slide-toggle>
        </div>
      }
    </div>
  </mat-card-actions>
</mat-card>